module.exports = __webpack_public_path__ + "f290f24295abde10ed5cc4c0c5cf1151.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/02_CH_PRI_03.png
// module id = 102
// module chunks = 0